import { FocusEvent } from 'react';

export const createOnBlur = <T extends HTMLElement>(
  className: string | string[],
  onBlur?: () => void,
) => {
  return (event: FocusEvent<T>) => {
    let parent = event.relatedTarget;
    const isClassList = Array.isArray(className);
    while (parent) {
      const classList = parent.classList;
      const classMatches = isClassList
        ? className.some((id) => classList.contains(id))
        : classList.contains(className);
      if (classMatches) {
        return;
      }
      parent = parent.parentElement;
    }
    onBlur?.();
  };
};

export const createFocusHandle = (id: string) => ({
  focus: () => {
    const isActiveInsideRelated = Array.from(
      document.getElementsByClassName(id),
    ).some((el) => el.contains(document.activeElement));

    // Only focus if the element does not already contain focus in any of its related elements
    if (!isActiveInsideRelated) {
      document.getElementById(id)?.focus();
    }
  },
});
